"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var useAuth_1 = require("../../useAuth");
var styledComponents_1 = require("../styledComponents");
var Logout = function () {
    var logout = (0, useAuth_1.useAuth)().logout;
    (0, react_1.useEffect)(function () {
        logout();
    }, [logout]);
    return (react_1.default.createElement(styledComponents_1.StyledContainer, null,
        react_1.default.createElement(styledComponents_1.StyledText, null, "Logging out..."),
        react_1.default.createElement(styledComponents_1.StyledLoader, null)));
};
exports.default = Logout;
